import React from "react";
import { Dictionary, filter, map } from "lodash";
import { Column } from "@/shared/ui/Blocks";
import { Title } from "@/shared/ui/Title";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { TopDimensionsComponentsList } from "@/features/profile/components/WisnioProfileHighlightsSection";
import { ContentSection, FlowingContent } from "../../../generator";
import { useProfileCompletion } from "@/features/profile/hooks/useProfileCompletion";
import { PersonalityMapSection } from "@/shared/widgets/PersonalityMapSection";
import { DimensionContext } from "@/types/data";
import DimensionDetailsContent from "@/shared/widgets/DimensionDetailsContent";
import { useTranslation } from "react-i18next";

interface HighlightsProps {
  dimensions: Dictionary<DimensionWithScores[]>;
  context: DimensionContext;
}

function HighlightsAndPersonality(props: HighlightsProps) {
  const { t } = useTranslation();
  const { dimensions, context } = props;

  const { personalityComplete } = useProfileCompletion(dimensions);

  const TopDimensionsComponents = TopDimensionsComponentsList({ dimensions });

  const personalityDimensions = filter(
    dimensions.personality,
    (d) => !d.parentId
  );

  if (!personalityComplete) return null;

  return (
    <FlowingContent className="mt-16">
      <Title as="h3" description={t("profile.highlights_description")}>
        {t("profile.highlights_title")}
      </Title>
      {TopDimensionsComponents}
      <Column className="my-16">
        <PersonalityMapSection
          dimensions={dimensions.personality}
          isPdf
          context="user"
        />
      </Column>
      {map(personalityDimensions, (dimension, index) => (
        <FlowingContent
          className="!mb-16"
          key={`personality-dimension-${dimension.id || index}`}
        >
          <DimensionDetailsContent
            allDimensions={dimensions.personality}
            dimension={dimension}
            context={context}
            // tags={tags}
            // insight={insight}
            showSubDimensions={false}
            showHeader
          />
        </FlowingContent>
      ))}
    </FlowingContent>
  );
}

export { HighlightsAndPersonality };
